(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Jurisdiction', Jurisdiction);

    Jurisdiction.$inject = ['$resource'];

    function Jurisdiction ($resource) {
        var resourceUrl =  'api/jurisdiction';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
